import BankAccount from "../../entities/bankAccount";

/**
 * BankAccount actions
 *
 * Call order:
 *
 * BANKACCOUNT_SAVE_QUEUE:	adds the item to the save queue
 * --> BANKACCOUNT_SAVE:	modifies the state
 * --> BANKACCOUNT_SAVE_SUCCESS: if all went well
 * --> BANKACCOUNT_SAVE_FAILURE:	if either the queue or local save failed
 *
 * Note that the only way to fail BANKACCOUNT_SAVE_QUEUE is during the call to BANKACCOUNT_SAVE,
 * as adding an item to the queue should never fail.
 */

export const BANKACCOUNT_FETCH_ONE_QUEUE: any = 'BANKACCOUNT_FETCH_ONE_QUEUE';
export const BANKACCOUNT_FETCH_SUCCESS: any = 'BANKACCOUNT_FETCH_SUCCESS';
export const BANKACCOUNT_FETCH_FAILURE: any = 'BANKACCOUNT_FETCH_FAILURE';
export const BANKACCOUNT_FETCH_ONE_SUCCESS: any = 'BANKACCOUNT_FETCH_ONE_SUCCESS';
export const BANKACCOUNT_FETCH_ONE_FAILURE: any = 'BANKACCOUNT_FETCH_ONE_FAILURE';

export const BANKACCOUNT_SAVE: any = 'BANKACCOUNT_SAVE';
export const BANKACCOUNT_SAVE_QUEUE: any = 'BANKACCOUNT_SAVE_QUEUE';
export const BANKACCOUNT_SAVE_SUCCESS: any = 'BANKACCOUNT_SAVE_SUCCESS';
export const BANKACCOUNT_SAVE_FAILURE: any = 'BANKACCOUNT_SAVE_FAILURE';

export const BANKACCOUNT_SAVE_MANY: any = 'BANKACCOUNT_SAVE_MANY';
export const BANKACCOUNT_SAVE_MANY_QUEUE: any = 'BANKACCOUNT_SAVE_MANY_QUEUE';
export const BANKACCOUNT_SAVE_MANY_SUCCESS: any = 'BANKACCOUNT_SAVE_MANY_SUCCESS';
export const BANKACCOUNT_SAVE_MANY_FAILURE: any = 'BANKACCOUNT_SAVE_MANY_FAILURE';

export const BANKACCOUNT_REMOVE: any = 'BANKACCOUNT_REMOVE';
export const BANKACCOUNT_REMOVE_QUEUE: any = 'BANKACCOUNT_REMOVE_QUEUE';
export const BANKACCOUNT_REMOVE_SUCCESS: any = 'BANKACCOUNT_REMOVE_SUCCESS';
export const BANKACCOUNT_REMOVE_FAILURE: any = 'BANKACCOUNT_REMOVE_FAILURE';

export const BANKACCOUNT_RESTORE: any = 'BANKACCOUNT_RESTORE';
export const BANKACCOUNT_RESTORE_QUEUE: any = 'BANKACCOUNT_RESTORE_QUEUE';
export const BANKACCOUNT_RESTORE_SUCCESS: any = 'BANKACCOUNT_RESTORE_SUCCESS';
export const BANKACCOUNT_RESTORE_FAILURE: any = 'BANKACCOUNT_RESTORE_FAILURE';

export const BANKACCOUNT_RESTORE_MANY: any = 'BANKACCOUNT_RESTORE_MANY';
export const BANKACCOUNT_REMOVE_MANY: any = 'BANKACCOUNT_REMOVE_MANY';

/* Fetch actions */
export const fetchBankAccountSuccess = (bankAccounts: BankAccount[], partial: boolean, lastFetch: number) => ({type: BANKACCOUNT_FETCH_SUCCESS, bankAccounts, partial, lastFetch});
export const fetchBankAccountFailure = (err: any) => {
		console.error('BankAccountAction: fetchBankAccountFailure', err);
		return {type: BANKACCOUNT_FETCH_FAILURE, err};
};
export const fetchOneBankAccountQueue = (bankAccountId: string) => ({type: BANKACCOUNT_FETCH_ONE_QUEUE, bankAccountId});
export const fetchOneBankAccountSuccess = (bankAccount: BankAccount) => ({type: BANKACCOUNT_FETCH_ONE_SUCCESS, bankAccount});
export const fetchOneBankAccountFailure = (id: string, err: any) => {
		console.error('BankAccountAction: fetchOneBankAccountFailure', err);
		return {type: BANKACCOUNT_FETCH_ONE_FAILURE, id, err};
};

/* Save actions */
export const saveBankAccount = (bankAccount: BankAccount) => {
    // console.debug('⮂ BANKACCOUNT_SAVE action', bankAccount?.id);
    return {type: BANKACCOUNT_SAVE, bankAccount};
}
export const saveBankAccountQueue = (bankAccount: BankAccount) => {
    // console.debug('⮂ BANKACCOUNT_SAVE_QUEUE action', bankAccount?.id);
    return {type: BANKACCOUNT_SAVE_QUEUE, bankAccount};
}
export const saveBankAccountSuccess = (bankAccount: BankAccount) => {
    // console.debug('⮂ BANKACCOUNT_SAVE_SUCCESS action', bankAccount?.id);
    return {type: BANKACCOUNT_SAVE_SUCCESS, bankAccount};
}
export const saveBankAccountFailure = (bankAccount: BankAccount, status: number, message: string) => {
    console.warn(`⮂ BANKACCOUNT_SAVE_FAILURE error saving bankAccount: HTTP ${status}: ${message}`, bankAccount?.id);
    return {type: BANKACCOUNT_SAVE_FAILURE, bankAccount, status, message};
};

/* SaveMany actions */
export const saveManyBankAccounts = (bankAccounts: BankAccount[]) => {
    // console.debug('⮂ BANKACCOUNT_SAVE_MANY action', bankAccounts?.map(bankAccount => bankAccount?.id).join(','));
    return {type: BANKACCOUNT_SAVE_MANY, bankAccounts};
}
export const saveManyBankAccountsQueue = (bankAccounts: BankAccount[]) => {
    // console.debug('⮂ BANKACCOUNT_SAVE_MANY_QUEUE action', bankAccounts?.map(bankAccount => bankAccount.id).join(','));
    return {type: BANKACCOUNT_SAVE_MANY_QUEUE, bankAccounts};
}

export const saveManyBankAccountsSuccess = (bankAccounts: BankAccount[]) => {
    // console.debug('⮂ BANKACCOUNT_SAVE_MANY_SUCCESS action', bankAccounts?.map(bankAccount => bankAccount.id).join(','));
    return {type: BANKACCOUNT_SAVE_MANY_SUCCESS, bankAccounts};
}
export const saveManyBankAccountsFailure = (bankAccounts: BankAccount[], status: number, message: string) => {
		console.warn(`⮂ SAVE_MANY_BANKACCOUNTS_FAILURE Error saving bankAccounts: HTTP ${status}: ${message}`, bankAccounts?.map(bankAccount => bankAccount.id).join(','));
		return {type: BANKACCOUNT_SAVE_MANY_FAILURE, bankAccounts, status, message};
};

/* Remove actions */
export const removeBankAccount = (bankAccount: BankAccount) => ({ type: BANKACCOUNT_REMOVE, bankAccount });
export const removeBankAccountQueue = (bankAccount: BankAccount) => ({ type: BANKACCOUNT_REMOVE_QUEUE, bankAccount });
export const removeBankAccountSuccess = (bankAccount: BankAccount) => ({ type: BANKACCOUNT_REMOVE_SUCCESS, bankAccount });
export const removeBankAccountFailure = (bankAccount: BankAccount, status: number, message: string) => {
	console.error(`Redux: removeBankAccountFailure Error removing bankAccount: HTTP ${status}: ${message}`);
	return ({ type: BANKACCOUNT_REMOVE_FAILURE, bankAccount, status, message });
};

/* Restore actions */
export const restoreBankAccount = (bankAccount: BankAccount) => ({ type: BANKACCOUNT_RESTORE, bankAccount });
export const restoreBankAccountQueue = (bankAccount: BankAccount) => ({ type: BANKACCOUNT_RESTORE_QUEUE, bankAccount });
export const restoreBankAccountSuccess = (bankAccount: BankAccount) => ({ type: BANKACCOUNT_RESTORE_SUCCESS, bankAccount });
export const restoreBankAccountFailure = (bankAccount: BankAccount, status: number, message: string) => {
	console.error(`Redux: restoreBankAccountFailure Error restoring bankAccount: HTTP ${status}: ${message}`);
	return ({ type: BANKACCOUNT_RESTORE_FAILURE, bankAccount, status, message });
};

/* RestoreMany actions */
export const restoreManyBankAccounts = (bankAccounts: BankAccount[]) => ({ type: BANKACCOUNT_RESTORE_MANY, bankAccounts });

/* RemoveMany actions */
export const removeManyBankAccounts = (bankAccounts: BankAccount[]) => ({ type: BANKACCOUNT_REMOVE_MANY, bankAccounts });